module.exports = __webpack_public_path__ + "static/media/potluck-planner.40558f72.png";